module.exports = __webpack_public_path__ + "static/media/imagem-escudo.cef86d25.png";